import axios from "axios";
import Cookies from "js-cookie";
import { CONFIG } from "../../config";
export const GetLessonDetailsWithCourseId = async (courseId) => {
	try {
		const authToken = Cookies.get("authToken");
		const response = await axios.post(
			`${CONFIG.COURSEURL}/api/v2/videos/course-videos`,
			{ courseId },
			authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined
		);
		return response.data;
	} catch (error) {
		// returning blank array after getting server and internet error
		return [];
	}
};
